
import { saveToLocalStorage, getFromLocalStorage } from '@/utils/storage';

/**
 * Saves the promo code to local storage
 */
export const savePromoCodeToStorage = (userId: string, promoCode: string): void => {
  saveToLocalStorage(`applied_promo_code_${userId}`, promoCode);
};

/**
 * Gets the promo code from local storage
 */
export const getPromoCodeFromStorage = (userId: string): string => {
  return getFromLocalStorage(`applied_promo_code_${userId}`) || '';
};

/**
 * Saves the applied credit to local storage
 */
export const saveAppliedCreditToStorage = (userId: string, amount: number): void => {
  saveToLocalStorage(`applied_credit_${userId}`, amount);
};

/**
 * Gets the applied credit from local storage
 */
export const getAppliedCreditFromStorage = (userId: string): number => {
  const savedCredit = getFromLocalStorage(`applied_credit_${userId}`);
  return typeof savedCredit === 'number' ? savedCredit : 0;
};

/**
 * Clears the cart storage for a specific user
 */
export const clearCartStorage = (userId: string): void => {
  localStorage.removeItem(`cart_${userId}`);
  localStorage.removeItem(`applied_promo_code_${userId}`);
  localStorage.removeItem(`applied_credit_${userId}`);
  console.log('Cart storage cleared for user:', userId);
};

/**
 * Clears all cart storage (for all users)
 */
export const clearAllCartStorage = (): void => {
  // Find all keys in localStorage that start with cart_, applied_promo_code_, or applied_credit_
  Object.keys(localStorage).forEach(key => {
    if (
      key.startsWith('cart_') || 
      key.startsWith('applied_promo_code_') || 
      key.startsWith('applied_credit_')
    ) {
      localStorage.removeItem(key);
    }
  });
  console.log('All cart storage cleared');
};
